import React from 'react';
import s from './Tooltip.css';

class Tooltip extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            displayTooltip: false
        }
        this.hideTooltip = this.hideTooltip.bind(this)
        this.showTooltip = this.showTooltip.bind(this)
    }

    hideTooltip () {
       this.setState({displayTooltip: false})
    }
    showTooltip () {
        this.setState({displayTooltip: true})
    }

    render() {
        let message = this.props.message
        let display = this.props.display;
        return (

                <span className={s.tooltip}
                      onMouseLeave={this.hideTooltip}
                >
                    {this.state.displayTooltip && display &&
                    <div className={s.tooltip_bubble}>
                        <div className={s.tooltip_message}>{message}</div>
                    </div>
                    }
                    <span
                        className={s.tooltip_trigger}
                        onMouseOver={this.showTooltip}
                    >
                  {this.props.children}
                </span>
             </span>
        )
    }
}

export default (Tooltip);


// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.js